/**
 * The decoration of the page's dark surfaces (the API panel and the close), all behind the content: a primary hairline
 * along the top edge, a primary glow rising from the top left and a cooler one low on the right (the professionals
 * rings' teal-to-blue, dimmed), and a fine dot grid that fades out downward. It pairs with the `INK` ground, a dark
 * tinted toward the primary so the green reads as part of it rather than on top of it. The parent needs
 * `relative isolate overflow-hidden`. The glows are radial gradients, not blurred circles: a blur that large is costly
 * to paint on a phone, on every scroll that brings it in.
 */
export function InkBackdrop() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
      <span className="via-primary/60 absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent to-transparent" />
      <span className="absolute -top-64 -left-56 size-[56rem] [background:radial-gradient(closest-side,color-mix(in_oklch,var(--primary)_16%,transparent)_40%,transparent)]" />
      <span className="absolute -right-[17.5rem] -bottom-6 size-[45rem] [background:radial-gradient(closest-side,color-mix(in_oklch,var(--color-sky-400)_8%,transparent)_33%,transparent)]" />
      <span className="absolute inset-0 [background-image:radial-gradient(rgb(255_255_255/0.075)_1px,transparent_1.2px)] [mask-image:radial-gradient(ellipse_80%_70%_at_30%_0%,black,transparent)] [background-size:22px_22px]" />
    </div>
  )
}

export const INK = 'bg-[#152321]'
